import {
    Box,
    Grid,
    GridProps,
    Text,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { LuX } from 'react-icons/lu';
import styles from './Sidebar.module.scss';

type SideBarProps = {
    label?: string,
    open: boolean,
    setOpen: (v: boolean) => void,
} & GridProps & React.RefAttributes<HTMLDivElement>

export const Sidebar: React.FC<SideBarProps> = ({
    label,
    open = false,
    setOpen,
    children,
    ...props
}) => {
    const [href] = useState(window.location.href);
    useEffect(() => {
        if (href !== window.location.href) {
            setOpen(false);
        }
    }, [window.location.href]);

    useEffect(() => {
        if (open) document.documentElement.style.overflow = 'hidden';
        else document.documentElement.style.overflow = 'scroll';

        return () => {
            document.documentElement.style.overflow = 'scroll';
        };
    }, [open]);
    return (
        <>
            <Box
                overscrollBehavior="contain"
                display={open ? 'block' : 'none'}
                height="100vh"
                width="100%"
                zIndex={29}
                background="rgba(0, 0, 0, 0.4)"
                position="fixed"
                onClick={() => setOpen(false)}
                cursor="pointer"
                className={styles.sidebarBackground}
            />
            <Grid
                overscrollBehavior="contain"
                position="fixed"
                top={0}
                height="100%"
                width={{
                    base: '100%',
                    lg: 'fit-content',
                }}
                transition="0.5s"
                zIndex={31}
                background="white"
                style={open ? {
                    transform: 'translateX(0)',
                } : {
                    transform: 'translateX(-110vw)',
                }}
                {...props}
                overflowY="scroll"
                templateRows="auto 1fr"
            >
                <Grid
                    templateColumns="1fr auto"
                    gap="2rem"
                    width="100%"
                    maxWidth={{
                        base: '425px',
                        lg: '1280px',
                    }}
                    margin="0 auto"
                    padding="2rem"
                >
                    <Text
                        margin="auto 0"
                        fontSize="3rem"
                        fontWeight="bold"
                        lineHeight={1}
                    >
                        {label}
                    </Text>
                    <Box
                        onClick={() => setOpen(false)}
                        padding="1rem"
                        margin="auto 0"
                        fontWeight={900}
                        cursor="pointer"
                        fontSize="2rem"
                        transition="0.25s"
                        _hover={{
                            color: '#E74C3C',
                        }}
                    >
                        <LuX size="2rem" />
                    </Box>
                </Grid>
                <Grid
                    height="fit-content"
                    width="100%"
                    maxWidth={{
                        base: '425px',
                        lg: '1280px',
                    }}
                    margin="0 auto"
                >
                    {children}
                </Grid>
            </Grid>
        </>
    );
};
